'use client';
import { createButtonTheme } from './utils/createButtonTheme';
const buttonThemesByTheme = new WeakMap();
const createButtonThemes = (theme) => {
    const { colors } = theme;
    return {
        navigation: createButtonTheme(colors.purple_2, colors.purple_1, colors.white_1, colors.purple_3, colors.purple_1, colors.white_1),
        'card-action': createButtonTheme(colors.grey_1, colors.grey_4, colors.white_1, colors.grey_3, colors.grey_1, colors.white_1),
        destructive: createButtonTheme(colors.red_1, colors.red_1, colors.white_1, colors.red_2, colors.red_2, colors.white_1),
        'main-action': createButtonTheme(colors.yellow_1, colors.yellow_1, colors.grey_1, colors.yellow_3, colors.yellow_1, colors.grey_1),
        success: createButtonTheme(colors.green_1, colors.green_1, colors.white_1, colors.green_2, colors.green_2, colors.white_1),
        outline: createButtonTheme(colors.white_1, colors.grey_1, colors.grey_1, colors.grey_1, colors.grey_1, colors.white_1),
    };
};
const getVariantButtonTheme = (theme, variant) => {
    let buttonThemes = buttonThemesByTheme.get(theme);
    if (!buttonThemes) {
        buttonThemes = createButtonThemes(theme);
        buttonThemesByTheme.set(theme, buttonThemes);
    }
    return buttonThemes[variant];
};
export default getVariantButtonTheme;
